import { useState, useEffect } from "react";

export default function InlineTextCell({ value, onSave, placeholder = "—", type = "text", label }) {
  const [draft, setDraft] = useState(value);
  useEffect(() => { setDraft(value); }, [value]);
  return (
    <input type={type} aria-label={label} value={draft} onChange={(e) => setDraft(e.target.value)}
      onBlur={() => { if (draft !== value) onSave(draft); }}
      onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
      placeholder={placeholder}
      className={`${type === "date" ? "w-auto" : "w-full"} bg-transparent border-none outline-none text-gray-300 text-sm p-0`} />
  );
}
